import React, { useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Menu from "../Menu/Menu"
import { HeaderTypes, ItemsProps } from "../Header"

type SolutionsQuery = {
  solutionsJson: { solutions: Array<{ title: string; slug: string }> }
}

const SolutionsMenu = ({ showOptions, handleToggleOptions }: ItemsProps) => {
  const data = useStaticQuery<SolutionsQuery>(solutionsQuery)

  const solutionItems = useMemo(() => {
    return {
      [HeaderTypes.SOLUTIONS]: data.solutionsJson.solutions.map(i => ({
        name: i.title,
        slug: `/solutions/${i.slug}/`,
      })),
    }
  }, [data.solutionsJson.solutions])

  return (
    <Menu
      title={HeaderTypes.SOLUTIONS}
      items={solutionItems}
      showOptions={showOptions}
      handleToggleOptions={handleToggleOptions}
    />
  )
}

export default SolutionsMenu

const solutionsQuery = graphql`
  query solutionsQuery {
    solutionsJson {
      solutions {
        title
        slug
      }
    }
  }
`
